'use client';

import { useState } from 'react';
import { EmailRequestForm } from './email-request-form';
import { ResetPasswordForm } from './reset-password-form';

type FormStep = 'email' | 'reset-password';

export function ForgotPasswordForm() {
    const [step, setStep] = useState<FormStep>('email');
    const [email, setEmail] = useState('');

    const handleOtpSent = (sentEmail: string) => {
        setEmail(sentEmail);
        setStep('reset-password');
    };

    const handleBackToEmail = () => {
        setStep('email');
        setEmail('');
    };

    if (step === 'reset-password') {
        return (
            <ResetPasswordForm
                email={email}
                onBackToEmail={handleBackToEmail}
            />
        );
    }

    return <EmailRequestForm onOtpSent={handleOtpSent} />;
}
